<div
    class="mega-menu-container"
    [class.show]="isVisible"
    [class.logged-in]="isAuthed$ | async"
    (menuMouseenter)="onMouseEnter()"
    (menuMouseleave)="onMouseLeave()"
    tabindex="-1">
    <div class="mega-menu-title">{{ title }}</div>
    <div class="mega-menu-grid">
        <ng-container *ngFor="let section of menuSections">
            <!-- Regular Menu Section -->
            <div class="menu-section" *ngIf="!section.type && section.items && section.items.length > 0">
                <h3>{{ section.title }}</h3>
                <ul>
                    <li *ngFor="let item of section.items; trackBy: trackByItem">
                        <ng-container *ngIf="!item.authed">
                            <button
                                *ngIf="item.loadsInFrame; else externalLink"
                                (click)="handleOpenDialog(item)"
                                aria-haspopup="dialog">
                                {{ item.label }}
                            </button>
                            <ng-template #externalLink>
                                <a
                                    *ngIf="item.href; else routerLink"
                                    [href]="item.href"
                                    target="_blank"
                                    (click)="onMouseLeave()"
                                    tabindex="0">
                                    {{ item.label }}
                                </a>
                            </ng-template>
                            <ng-template #routerLink>
                                <a
                                    *ngIf="!item.fragment; routerLinkWithHash"
                                    [routerLink]="item.routerLink"
                                    [queryParams]="queryParams"
                                    (click)="onMouseLeave()"
                                    tabindex="0">
                                    {{ item.label }}
                                </a>
                            </ng-template>
                            <ng-template #routerLinkWithHash>
                                <a
                                    [routerLink]="item.routerLink"
                                    [queryParams]="queryParams"
                                    [fragment]="item.fragment"
                                    (click)="onMouseLeave()"
                                    tabindex="0">
                                    {{ item.label }}
                                </a>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="item.authed">
                            <ng-container *appAuthed>
                                <ng-container *ngIf="portalAccess$ | async as portalAccess">
                                    <ng-container *ngIf="shouldShowPortal(item, portalAccess)">
                                        <a
                                            *ngIf="item.routerLink; else authedExternalLink"
                                            [routerLink]="item.routerLink"
                                            [queryParams]="queryParams"
                                            (click)="onMouseLeave()"
                                            tabindex="0">
                                            {{ item.label }}
                                        </a>
                                        <ng-template #authedExternalLink>
                                            <a [href]="item.href" target="_blank" (click)="onMouseLeave()" tabindex="0">
                                                {{ item.label }}
                                            </a>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </li>
                </ul>
            </div>

            <!-- Spotlight Section (shown only for unauthenticated users) -->
            <ng-container *ngIf="section.type === 'spotlight'">
                <div class="menu-section spotlight" *ngIf="!(isAuthed$ | async)">
                    <h3>{{ section.title }}</h3>
                    <div class="spotlight-content">
                        <img [src]="section.content?.image" [alt]="section.content?.title" class="spotlight-image" />
                        <h4 class="spotlight-title">{{ section.content?.title }}</h4>
                        <p class="spotlight-description">{{ section.content?.description }}</p>
                        <a
                            *ngIf="section.content?.buttonLink; else signInLink"
                            [routerLink]="section.content?.buttonLink"
                            [queryParams]="queryParams"
                            class="spotlight-link">
                            {{ section.content?.buttonText }}
                            <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                        </a>
                        <ng-template #signInLink>
                            <a class="spotlight-link" (click)="handleSpotlightAction(section)">
                                {{ section.content?.buttonText }}
                                <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                            </a>
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
